import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
}

export default function Seo({ title, description, path = "", type = "website", jsonLd, noindex = false }) {
  useEffect(() => {
    const full = title ? `${title} — UK Ready` : "UK Ready — Would you know what to do?";
    document.title = full;
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    upsertMeta("property", "og:title", full);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", "UK Ready");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", full);
    const ogImg = window.location.origin + "/og-image.png";
    upsertMeta("property", "og:image", ogImg);
    upsertMeta("property", "og:image:width", "1200");
    upsertMeta("property", "og:image:height", "630");
    upsertMeta("property", "og:image:alt", "UK Ready — Would you know what to do?");
    upsertMeta("name", "twitter:image", ogImg);
    const site = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, "");
    const clean = (window.location.pathname.replace(/\/+$/, "") || "/");
    const url = site + (clean === "/" ? "/" : clean);
    upsertMeta("property", "og:url", url);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement("link"); canon.setAttribute("rel", "canonical"); document.head.appendChild(canon); }
    canon.setAttribute("href", url);

    let script = document.getElementById("ld-json");
    const data = jsonLd || {
      "@context": "https://schema.org", "@type": "WebSite", name: "UK Ready",
      url: window.location.origin,
      description: "Independent UK public-information service for emergency preparedness and live information.",
    };
    if (!script) { script = document.createElement("script"); script.id = "ld-json"; script.type = "application/ld+json"; document.head.appendChild(script); }
    script.textContent = JSON.stringify(data);
  }, [title, description, path, type, jsonLd, noindex]);
  return null;
}
